import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

import { CBadge } from '@coreui/react'
import { _dictionary } from '../utils/translate'
import { useAppSelector } from '../redux/hooks'
import { selectCurrentUser } from '../redux/features/currentUser/currentUserSlice'

export const AppSidebarNav = ({ items }) => {
  const currentUser = useAppSelector(selectCurrentUser)
  const translate = _dictionary(currentUser?.active_language || null)
  const location = useLocation()
  const [navItems, setNavItems] = React.useState(items)

  React.useEffect(() => {
    setNavItems(addEnabledDisplayFlag(navItems))
  }, [currentUser])

  const addEnabledDisplayFlag = React.useCallback(
    (navItem) => {
      const userPermissions = currentUser?.permissions || {}
      const itemsWithPermissionFlag = navItem.map((item) => {
        if (item.items) {
          item.items = addEnabledDisplayFlag(item.items)
          item.enabledDisplay = item.items.some((item) => item.enabledDisplay) || false
        } else {
          item.enabledDisplay =
            userPermissions?.[item.permissionSource]?.some(
              (p) => p === (item?.permissionKey || 'find'),
            ) || false
        }
        return item
      })
      return itemsWithPermissionFlag
    },
    [currentUser],
  )
  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && translate(name)}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item, index) => {
    const { component, name, badge, icon, enabledDisplay, ...rest } = item
    const Component = component
    return (
      enabledDisplay && (
        <Component
          {...(rest.to &&
            !rest.items && {
              component: NavLink,
              activeClassName: 'active',
            })}
          key={index}
          {...rest}
        >
          {navLink(name, icon, badge)}
        </Component>
      )
    )
  }
  const navGroup = (item, index) => {
    const { component, name, icon, to, enabledDisplay, ...rest } = item
    const Component = component
    return (
      enabledDisplay && (
        <Component
          idx={String(index)}
          key={index}
          toggler={navLink(name, icon)}
          visible={location.pathname.startsWith(to)}
          {...rest}
        >
          {item.items?.map((item, index) =>
            item.items ? navGroup(item, index) : navItem(item, index),
          )}
        </Component>
      )
    )
  }
  return (
    <React.Fragment>
      {navItems &&
        navItems.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  )
}

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
